import service from "@/utils/request";
// 搜索列表
export interface autoSearchData {
  page: number;
  page_size: number;
  key_word?: string;
  name?: string;
  title?: string;
  status?: number | number[];
  course_type?: number;
  mobile?: number | string;
  on_job?: number;
  sales_status?: number | string;
  job_ids?: number[];
  is_teach?: number;
  select_type?: number; // 此参数只针对教师点评需求，查询出被删除的班级数据
}

// 员工搜索列表
export const staffList = (data: autoSearchData) => {
  if (!data.status) {
    data.status = 1;
  }
  return service({
    url: "/api/v1/staff/search/list",
    method: "post",
    data,
  });
};

// 教师搜索列表
export const geteacherList = (params: autoSearchData) => {
  return service({
    url: "/api/v1/teacher/search/list",
    method: "get",
    params,
  });
};
// 班级搜索列表
export const getSelectClassList = (params: any) => {
  return service({
    url: "/api/v1/class/select_list",
    method: "get",
    params,
  });
};
// 课程搜索列表
export const getSelectCourseList = (params: autoSearchData) => {
  return service({
    url: "/api/v1/course/search/list",
    method: "get",
    params,
  });
};
// 科目搜索列表
export const getSeleSubjectsList = (params: autoSearchData) => {
  return service({
    url: "/api/v1/subjects/list",
    method: "get",
    params,
  });
};
// 学员搜索列表
export const searchStudent = (data: autoSearchData) => {
  return service({
    url: "/api/v1/student/select_list",
    method: "post",
    data,
  });
};

// 通用商品搜索
export interface commonSearchGoodsData {
  page: number;
  page_size: number;
  key_word?: string;
}
export const commonSearchGoodsApi = (params: commonSearchGoodsData) => {
  return service({
    url: "/api/v1/integral/goods/search",
    method: "get",
    params,
  });
};
